export const NEWS_LETTER_FILES_RESET_STATE = 'NEWS_LETTER_FILES_RESET_STATE';
export const NEWS_LETTER_FILES_CURRENT_ITEM = 'NEWS_LETTER_FILES_CURRENT_ITEM';

export const NEWS_LETTER_FILES_REQUEST_LOADING = 'NEWS_LETTER_FILES_REQUEST_LOADING';
export const NEWS_LETTER_FILES_REQUEST_SUCCESS = 'NEWS_LETTER_FILES_REQUEST_SUCCESS';
export const NEWS_LETTER_FILES_REQUEST_FAILED = 'NEWS_LETTER_FILES_REQUEST_FAILED';

export const NEWS_LETTER_FILES_CURRENT_ACTION = 'NEWS_LETTER_FILES_CURRENT_ACTION';
export const NEWS_LETTER_FILES_RESET_ACTION = 'NEWS_LETTER_FILES_RESET_ACTION';